import { LOCAL_STORAGE } from '@constants';
import SignupImage from 'assets/images/signup.jpg';
import PublicHeader from 'routes/PublicHeader';
import CorporateDocumentation from 'screens/SignUp/Documentation/CorporateDocumentation';

export default function withCorporateDocumentation(Component) {
  const WithCorporateDocumentationWrapper = function (props) {
    const showDocumentationScreen =
      localStorage.getItem(LOCAL_STORAGE.SHOW_DOCUMENTATION_SCREEN) === 'true';

    if (!showDocumentationScreen) {
      return <Component {...props} />;
    }

    return (
      <>
        <PublicHeader />
        <div className="content content--no-navigation">
          <div className="u-ovh">
            <div className="row justify-content-center">
              <div className="row col-12">
                <div className="col-lg-6">
                  <img className="img-login-signup" src={SignupImage} alt="signup" />
                </div>

                <div className="col-12 col-sm-10 col-md-8 col-lg-4 offset-sm-1 offset-md-2 offset-lg-1">
                  <CorporateDocumentation />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return WithCorporateDocumentationWrapper;
}
